<template>
  <div id="page-user-edit">

    <vs-alert color="danger" title="Student Not Found" :active.sync="user_not_found">
      <span>Student record with id: {{ $route.params.studentId }} not found or not a valid student. </span>
      <span>
        <span>Check </span><router-link :to="{name:'students'}" class="text-inherit underline">All Sudents</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="user_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Account" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <user-edit-tab-account class="mt-4" :data="user_data" />
            </div>
          </vs-tab>
          <vs-tab label="Results" icon-pack="feather" icon="icon-truck">
            <div class="tab-text">
              <user-edit-tab-information class="mt-4" :data="user_data" :results="results" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import UserPackage from "./UserPackage.vue"
import UserEditTabSocial from "./UserEditTabSocial.vue"
import UserEditTabAccount from "./UserEditTabAccount.vue"
import UserEditTabInformation from "./UserEditTabInformation.vue"
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    UserEditTabAccount,
    UserEditTabInformation,
    UserEditTabSocial,
    UserPackage,
  },
  data() {
    return {
      user_data: null,
      results: [],
      user_not_found: false,
      activeTab: 0,
    }
  },
  watch: {
    activeTab() {
      this.fetch_user_data(this.$route.params.studentId)
    }
  },
  methods: {
    fetch_user_data(userId) {
      this.$store.dispatch("userManagement/fetchStudent", userId)
        .then(res => { 
          if(res.data.role == "student"){
            this.user_data = res.data 
            this.fetch_user_results(userId)
          }
          else this.user_not_found = true
        })
        .catch(err => {
          if(err.response && err.response.status && err.response.status === 404) {
            this.user_not_found = true
            return
          }
          // console.error(err) 
        })
    },
    fetch_user_results(userId) {
      this.$store.dispatch("userManagement/fetchStudentResults", {student_id : userId})
        .then(res => { 
          this.results = res.data
        })
        .catch(err => {

        })
    }
  },
  mounted(){
    this.fetch_user_data(this.$route.params.studentId)
  },
  created() {
    // Register Module UserManagement Module
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    
  }
}

</script>
